// extracted by mini-css-extract-plugin
var _1 = "_tabPageHeaderWrapper-module__header-container";
export { _1 as "header-container" }
